var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({attrs:{"id":_vm.id ? `c${_vm.id}` : undefined}},'a',_vm.newAttrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }